import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-advanced-carousel-skeleton',
  templateUrl: './advanced-carousel-skeleton.component.html',
  styleUrls: ['./advanced-carousel-skeleton.component.scss'],
})
export class AdvancedCarouselSkeletonComponent {
  @Input() isLandScapeTablet: boolean;
  @Input() isDesktop: boolean;
  @Input() isTablet: boolean;
  @Input() isMobile: boolean;
}
